// Fase 7A — Host per il Contact Drawer nelle pagine cross-tenant (Calendario/
// Richiami). Avvolge il Drawer in un ApiProvider legato al tenant del contatto,
// così note/prenotazioni usano i record reali del salone giusto.
import { useMemo } from "react";
import { createAgencyClient } from "@/lib/api";
import { ApiProvider } from "@/lib/apiClient";
import ContactDrawer from "@/pages/admin/agency/ContactDrawer";

export default function AgencyContactDrawerHost({ clientId, tenant, caseObj, onClose, onUpdated }) {
  const client = useMemo(() => createAgencyClient(() => tenant?.id), [tenant?.id]);
  if (!clientId || !tenant) return null;
  return (
    <ApiProvider client={client}>
      <ContactDrawer clientId={clientId} tenant={tenant} caseObj={caseObj} onClose={onClose} onUpdated={onUpdated} />
    </ApiProvider>
  );
}
